import dayjs from 'dayjs'
import { ActionFunctionArgs, redirect } from 'react-router-dom'
import { z } from 'zod'

import { patientSchema } from '@/schema.ts'
import { action as createAppointmentAction } from '@/screens/createAppointmentAction.ts'
import { useAppointmentStore } from '@/store.ts'
import { isValidDateOfBirth } from '@/utils/getAllowedTreatmentsVelthuis.ts'

interface ActionData {
  errors?: z.ZodIssue[]
  error?: string
}

const action = async ({
  request,
}: ActionFunctionArgs): Promise<ActionData | Response> => {
  const { appointmentType, setError, setPatientData } =
    useAppointmentStore.getState()
  const formData = await request.formData()
  const dateOfBirth = dayjs(
    String(formData.get('dateOfBirth')),
    'DD/MM/YYYY',
    true,
  ).format('YYYY-MM-DD')

  const patientData = {
    dateOfBirth,
    email: String(formData.get('email')),
    firstName: String(formData.get('firstName')),
    gender: String(formData.get('gender')),
    houseNumber: String(formData.get('houseNumber')),
    initials: String(formData.get('initials')),
    lastName: String(formData.get('lastName')),
    phone: String(formData.get('phone')),
    postalCode: String(formData.get('postalCode')),
  }

  const result = patientSchema.safeParse(patientData)
  if (!result.success) {
    setPatientData(patientData)
    return { errors: result.error.issues }
  }

  setPatientData(result.data)

  if (!isValidDateOfBirth(dateOfBirth, appointmentType!)) {
    setError('canNotAcceptPatientsUnder18')
    return redirect('/error')
  }
  return createAppointmentAction()
}

export type { ActionData }
export { action }
